type RichTextResource = {
  type: 'plain' | 'markdown';
  locale: 'en-US' | 'sv-SE' | string;
  content: string;
}[];

export function extractPlainTextFromRichText(
  richTextResource?: RichTextResource | null,
  locale = 'en-US',
) {
  if (!richTextResource) return;

  return richTextResource.find(
    (richText) => richText.type === 'plain' && richText.locale === locale,
  )?.content;
}
